module.exports = {"MatchBusinessUnit":"Match Business Units","MatchCostCenter":"Match Cost Centers","OverridePreviousSteps":"May override previous steps","RequestEveryTime":"May request every time","UseHierarchyApproval":"Match Management Level"}


//////////////////
// WEBPACK FOOTER
// ./src/components/_modules/Approvals/Approval-rule/action-add-options.json
// module id = k9o7
// module chunks = 12